/**
 * h5 客态页面
 */
import React, { useEffect, useRef, useState } from 'react';
import VideoPlayer from '../../../components/VideoPlayer';
import { mergeCssStyles } from '../../../../lib/utils';
import style from './index.module.scss';
const H5GuestPage = ({ isVideo, playBtnImgUrl, showArea, onPlayClick, customStyle, validateUrl, resUrl, posterUrl, isNeedAutoPlayHiddenBtn, videoFrameImgUrl, children, }) => {
    const [displayUrl, setDisplayUrl] = useState('');
    const [displayPoster, setPoster] = useState('');
    const videoPlayerRef = useRef(null);
    const mergeStyle = customStyle ? mergeCssStyles(style, customStyle) : style;
    useEffect(() => {
        if (resUrl === null || resUrl === void 0 ? void 0 : resUrl.startsWith(validateUrl)) {
            setDisplayUrl(resUrl);
            // 如果有 poster 就设置
            (posterUrl === null || posterUrl === void 0 ? void 0 : posterUrl.startsWith(validateUrl)) && setPoster(posterUrl);
        }
    }, []);
    const getResultPanel = () => (React.createElement("div", { className: mergeStyle['guest-panel'] }, isVideo ? (React.createElement("div", { className: mergeStyle['video-panel'] },
        React.createElement(VideoPlayer, { videoUrl: displayUrl, ref: videoPlayerRef, posterImgUrl: displayPoster, isNeedAutoPlayHiddenBtn: isNeedAutoPlayHiddenBtn }),
        videoFrameImgUrl ? (React.createElement("img", { src: videoFrameImgUrl, className: mergeStyle['video-mask'], alt: "" })) : null)) : (React.createElement("div", { className: mergeStyle['image-panel'] },
        React.createElement("img", { src: displayUrl, alt: "alt" })))));
    const handlePlayClick = () => {
        var _a;
        (_a = videoPlayerRef.current) === null || _a === void 0 ? void 0 : _a.pause();
        onPlayClick();
    };
    return (React.createElement("div", { className: mergeStyle['guest-page'] },
        React.createElement("div", { className: mergeStyle['content-wrapper'] },
            showArea ? showArea : getResultPanel(),
            React.createElement("img", { "data-btn-id": "guest#play", src: playBtnImgUrl, alt: "", className: mergeStyle.play, onClick: handlePlayClick })),
        children));
};
export default H5GuestPage;
